// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3lN3Q","label":"Radio_label__Qrr82","checkMark":"Radio_checkMark__1BjKN","disabled":"Radio_disabled__3HKrH"};